import {
  Dialog,
  //DialogTitle,
  //DialogContent,
  Typography,
  Stack,
  Chip,
  Box,
  Grid,
  Button,
} from "@mui/material";
import { openWhatsApp } from "../components/contact_sources";


//import { useEffect, useState } from "react";
export default function CakeDetailsDialog({ cake, open, onClose }) {
  // const startDate = new Date("2026-04-01T00:00:00");
  // const endDate = new Date(startDate.getTime() + 365 * 24 * 60 * 60 * 1000);

  // const [timeLeft, setTimeLeft] = useState(endDate - new Date());

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeLeft(endDate - new Date());
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, []);

  // const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  // const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  // const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
  // const seconds = Math.floor((timeLeft / 1000) % 60);

  if (!cake) return null;

  return (
    <Dialog
      scroll="body"
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <Grid container sx={{ minHeight: "450px", bgcolor: "white" }}>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Box
            className="product-img"
            sx={{
              width: "100%",
              height: { xs: "220px", sm: "100%" },
              background: `url(${cake.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "transform 0.6s ease",
            }}
          >
            <Box
              sx={{
                height: "31px",
                width: "56px",
                bgcolor: "orange",
                position: "relative",
                left: "78%",
                top: 17,
                borderRadius: "31px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ color: "white", fontWeight: 600, fontSize: "13px" }}
              >
                ₹{cake.price}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          size={{ xs: 12, sm: 6 }}
          sx={{
            display: "flex",
          }}
        >
          <Stack
            sx={{ p: 2, display: "flex", justifyContent: "space-around" }}
            spacing={1}
          >
            <Box
              sx={{
                display: "flex",
                height: "30px",
                width: "90px",
                bgcolor: "#faf1e3",
                borderRadius: "20px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontWeight: 600, color: "#e99e26ff", fontSize: "13px" }}
              >
                {cake.category}
              </Typography>
            </Box>

            <Typography variant="h4">{cake.name}</Typography>
            <Typography sx={{ color: "#595959ff" }}>
              {cake.description}
            </Typography>
            {Number(cake.price) <= 1200 && (
              <>
                <Box
                  sx={{
                    height: "70px",
                    border: "2px solid #ffae00",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <img
                      width="48"
                      height="48"
                      src="https://img.icons8.com/color/48/confetti.png"
                      alt="confetti"
                    />
                  </Box>
                  <Stack>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        letterSpacing: 1,
                        fontWeight: 900,
                      }}
                    >
                      BUY 1 GET 1 FREE
                    </Typography>
                    <Typography sx={{ color: "grey", fontSize: "11px" }}>
                      @ ₹{cake.price === "900" ? "1200" : "1000"} only
                    </Typography>
                    <Typography sx={{ color: "grey", fontSize: "11px" }}>
                      Limited time only
                    </Typography>
                  </Stack>
                  {/* <Lottie
                animationData={offerAnimation}
                loop={true}
                style={{ width: 60, height: 60, transform: "scale(2.5)"}}
                
              /> */}
                </Box>
                <Typography sx={{ color: "grey", fontSize: "11px" }}>
                  Note: You may choose another cake in any flavor under the
                  offer price.
                </Typography>
              </>
            )}

            <Typography
              variant="h5"
              sx={{ fontSize: "17px", letterSpacing: 1 }}
            >
              Key Ingredients
            </Typography>
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {cake.ingredients.slice(0, 4).map((item, index) => (
                <Chip
                  key={index}
                  label={item}
                  sx={{
                    borderRadius: "20px",
                    backgroundColor: "#f3eee7",
                    border: "1px solid #d6cfc7",
                    fontWeight: 500,
                    px: 1,
                  }}
                />
              ))}
            </Stack>
            <Button
              onClick={() => openWhatsApp(cake)}
              sx={{
                mt: "auto",
                background: "linear-gradient(45deg, #f29c24, #d56d12)",
                borderRadius: "12px",
                px: 1.875,
                py: 1.075,
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                "&:hover": {
                  transform: "scale(1.02)", // enlarge
                  boxShadow: "0 2px 15px rgba(0,0,0,0.25)",
                  background: "linear-gradient(45deg,#d9a14a, #c28729)",
                },
              }}
            >
              Order Now
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Dialog>
  );
}
